module.exports = __webpack_public_path__ + "static/media/lito_mood.a84cf861.jpg";